import { createApp } from 'vue';
import { createPinia } from 'pinia';
import Vant from 'vant';
import 'vant/lib/index.css';
import './styles/reset.css';
import './styles/base.css';
import App from './App.vue';
import router from './router';
import api from './api';

if (import.meta.env.DEV) {
  import('@vant/touch-emulator');
}

const app = createApp(App);

// 将业务接口挂到 Vue 全局，Options API 可通过 this.$api 调用。
app.config.globalProperties.$api = api;
// 保留 provide 能力，兼容需要依赖注入的组合式组件。
app.provide('api', api);

app.use(createPinia());
app.use(router);
app.use(Vant);

app.mount('#app');
